import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FieldTree, FormField } from '@angular/forms/signals';
import { InstantFieldComponent } from '@evorait/pace-components';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faPause } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';

/**
 * The start-of-work and end-of-work rows.
 *
 * One component for both because they differ only in their label and in the end-of-work row's
 * extra button: each edits a single instant that brackets the working day.
 */
@Component({
    selector: 'pace-timesheet-marker-row',
    standalone: true,
    imports: [FaIconComponent, FormField, InstantFieldComponent, TranslateModule],
    templateUrl: './timesheet-marker-row.component.html',
    styleUrl: './timesheet-row.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimesheetMarkerRowComponent {
    /** which end of the day this row marks */
    public readonly marker = input.required<'sow' | 'eow'>();

    /** the instant this row edits */
    public readonly instant = input.required<FieldTree<string>>();

    /** ISO instants the picker is limited to; empty for no limit */
    public readonly minInstant = input('');
    public readonly maxInstant = input('');

    /**
     * Whether to offer collapsing the gap before the end of work.
     *
     * The technician often opens the timesheet after finishing, leaving a gap between the last
     * entry and "now"; this pulls the end of work back onto the last entry instead of making them
     * type it.
     */
    public readonly canCollapseGap = input(false);

    /** the user asked to pull the end of work back onto the last entry */
    public readonly collapseGap = output<void>();

    protected readonly faPause = faPause;
}
